export default __webpack_public_path__ + "static/epica-scheda-tecnica-2a8ecc7a7d5f14581b8249d817b71b7e.pdf";